// extracted by mini-css-extract-plugin
export default {"flex":"View_flex__081b9","flex_row":"View_flex_row__RrYsO","fullFlex":"View_fullFlex__a0yYG","center":"View_center__Lh6uT"};